import React, { useState } from 'react';
import { Sparkles, ArrowRight, Phone, Mail } from 'lucide-react';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.name && formData.email) {
      setSubmitted(true);
      setTimeout(() => {
        setSubmitted(false);
        setFormData({ name: '', email: '', phone: '', message: '' });
      }, 4000);
    }
  };

  return (
    <section className="contact-main-section">
      <div className="contact-main-wrapper">
        
        {/* Left Column: Image with Overlapping Dark Form Card */}
        <div className="contact-left-visual">
          <div className="contact-img-frame">
            <img
              src={process.env.PUBLIC_URL + '/images/contact-hero.jpg'}
              alt="Insurance Specialist Reviewing Policy"
              className="contact-desk-img"
            />
          </div>

          {/* Overlapping Dark Green Form Card */}
          <div className="contact-form-card">
            <h3 className="form-card-title">Have any questions?</h3>
            <p className="form-card-subtitle">
              Our experienced insurance experts are always ready to guide and support you properly.
            </p>

            <form onSubmit={handleSubmit} className="contact-form-inputs">
              <input
                type="text"
                placeholder="Your name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                className="form-input full-width"
              />

              <div className="form-input-row">
                <input
                  type="email"
                  placeholder="Your email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  className="form-input half-width"
                />
                <input
                  type="tel"
                  placeholder="Your number"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  className="form-input half-width"
                />
              </div>

              <textarea
                placeholder="Your message"
                rows="4"
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                className="form-textarea full-width"
              ></textarea>

              <button type="submit" className="btn-contact-submit">
                <span>{submitted ? 'Message Sent!' : 'Submit Now'}</span>
                <ArrowRight size={18} className="btn-arrow" />
              </button>
            </form>
          </div>
        </div>

        {/* Right Column: Heading, Subtitle & 2 Contact Cards */}
        <div className="contact-right-details">
          
          <div className="contact-badge">
            <Sparkles size={14} className="badge-icon" />
            <span>Secure together</span>
          </div>

          <h1 className="contact-hero-title">
            Let's find the right<br />protection!
          </h1>

          <p className="contact-hero-desc">
            Find reliable insurance coverage tailored to your needs lifestyle future goals, and
            financial security.
          </p>

          {/* 2 Contact Info Cards */}
          <div className="contact-cards-pair">
            
            {/* Card 1: Chat With Us */}
            <div className="contact-info-card">
              <div className="contact-card-icon-box">
                <Mail size={20} className="card-icon" />
              </div>
              <div className="contact-card-text">
                <span className="card-prefix">{'Chat with us'}</span>
                <a href="mailto:meenalic50@gmail.com" className="card-link-val">
                  meenalic50@gmail.com
                </a>
              </div>
            </div>

            {/* Card 2: Call Us */}
            <div className="contact-info-card">
              <div className="contact-card-icon-box">
                <Phone size={20} className="card-icon" />
              </div>
              <div className="contact-card-text">
                <span className="card-prefix">{'Call us'}</span>
                <a href="tel:+919710506057" className="card-link-val">
                  +91 9710506057
                </a>
              </div>
            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default ContactSection;
